import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceQuery(
  $tableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  tables(filter: { id: $tableId }) {
    downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
